// Constants to reduce magic numbers and improve maintainability
// Shared between web and React Native versions
export const CONSTANTS = {
  // Timing constants
  AUTO_HIDE_DELAY: 10000, // 10 seconds - Auto-hide timer for controls
  PROCESSING_DELAY: 1000, // 1 second delay for UI to settle (React Native file handling)
  CLEANUP_DELAY: 10000, // 10 seconds to clean up processed files (React Native)

  // Constraints
  MIN_SLOTS_PER_ROW: 1,
  MIN_ROWS_PER_SECTION: 1, // Web-specific constraint
  MIN_SECTIONS: 1, // Web-specific constraint

  // Defaults
  DEFAULT_SLOTS_COUNT: 2,

  // UI sizing
  TITLE_FONT_SIZE: 48, // Font size for project title
  TITLE_LINE_HEIGHT: 52, // Line height for project title
  FADE_HEIGHT: 20, // Height of the fade effect in pixels (React Native)

  // Lyrics Configuration
  LYRICS_MAX_CHARS: 60, // Maximum characters allowed in lyrics field
  LYRICS_FONT_SIZE: 10, // Can be overridden by theme.typography.sizes.sm
  LYRICS_PLACEHOLDER: 'Tap to write', // Placeholder text for empty lyrics input
  EMPTY_SLOT_PLACEHOLDER: 'Tap to\nadd chord', // Chord area of the active slot with no chord
  SILENCE_LABEL: 'Silence (no chord)', // Accessible name of the silence mark shown in a slot with no chord

  // Paste-to-chart import copy (web-only; React Native localizes these as pasteChart.*)
  PASTE_IMPORT_NOTICE: "Automatic conversion isn't perfect. After importing, check for misplaced chords, wrong section breaks and words read as chords.",
  // Example shown in the empty paste box (same as React Native's pasteChart.placeholder)
  PASTE_IMPORT_PLACEHOLDER:
    "[Verse]\n" +
    "G                  C\n" +
    "Chords go on their own line,\n" +
    "D               G\n" +
    "right above the words\n" +
    "\n" +
    "[Chorus]\n" +
    "[G]Or inside the [C]words, in [D]brackets",
  PASTE_IMPORT_REVIEW_REMINDER: 'Your chart was converted automatically, so give it a quick check for misplaced chords, wrong section breaks and words read as chords.',

  // Transpose Tip (shown periodically after Buffet import)
  BUFFET_IMPORT_COUNT_KEY: 'chordbaker_buffet_import_count',
  TRANSPOSE_TIP_DISMISSED_KEY: 'chordbaker_transpose_tip_dismissed',
  TRANSPOSE_TIP_FREQUENCY: 1, // Show tip on every Buffet import
} as const;
